var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "svg",
      {
        staticClass: "sidebaricon",
        attrs: {
          xmlns: "http://www.w3.org/2000/svg",
          fill: "#000000",
          viewBox: "0 0 50 50",
          width: "30px",
          height: "30px",
        },
        on: { click: _vm.CloseLeftsideBar },
      },
      [
        _c("path", {
          attrs: {
            d: "M 0 7.5 L 0 12.5 L 50 12.5 L 50 7.5 Z M 0 22.5 L 0 27.5 L 50 27.5 L 50 22.5 Z M 0 37.5 L 0 42.5 L 50 42.5 L 50 37.5 Z",
          },
        }),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }